<template>
  <div id="add_license" class="mb-4" v-if="geoContent && geoContent.products">
    <form class="add-license-form" v-on:submit.prevent="addLicense">
      <div class="add-license-main">
        <div class="form-field form-field-email">
          <label class="form-label" for="add-license-email">Email</label>
          <input
            id="add-license-email"
            type="email"
            class="form-control"
            v-model="email"
            placeholder="user@example.com"
            autocomplete="email"
            :disabled="issuing"
          />
        </div>

        <div class="form-field form-field-devnum">
          <label class="form-label" for="add-license-devnum">{{ $t('publisher.gc.lics.add.devnum') }}</label>
          <input
            id="add-license-devnum"
            type="number"
            min="0"
            class="form-control"
            v-model="devnum"
            placeholder="0"
            :title="$t('publisher.gc.lics.add.unlim')"
            :disabled="issuing"
          />
        </div>

        <div class="form-field form-field-type">
          <label class="form-label" for="add-license-type">{{ $t('publisher.gc.lics.add.lictype') }}</label>
          <p v-if="singleProduct" class="type-static">
            {{ $t('publisher.gc.lics.add.' + products[0].licType) }}
            <span v-if="products[0].licType === 'com'" class="hint">({{ products[0].price }})</span>
          </p>
          <select
            v-else
            id="add-license-type"
            class="form-control"
            v-model="prodid"
            :disabled="issuing"
          >
            <option :value="0">{{ $t('publisher.gc.lics.add.select') }}</option>
            <option v-for="prod in products" :key="prod.id" :value="prod.id">
              {{ $t('publisher.gc.lics.add.' + prod.licType) }}
              <template v-if="prod.licType === 'com'"> ({{ prod.price }})</template>
            </option>
          </select>
        </div>

        <div class="form-field form-field-action">
          <button
            type="submit"
            class="btn btn-primary text-nowrap"
            :disabled="issuing || !canSubmit"
          >
            <span
              v-if="issuing"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
              aria-hidden="true"
            ></span>
            {{ issuing ? 'Issuing…' : $t('publisher.gc.lics.add.issue') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    gcid: null
  },
  data() {
    return {
      email: "",
      exp: "12",
      devnum: "1",
      prodid: 0,
      issuing: false
    };
  },
  computed: {
    geoContent() {
      return this.$store.state.geoContent.geoContent;
    },
    products() {
      if (this.geoContent && this.geoContent.products) {
        return this.geoContent.products.filter(
          p => p.licType === "com" || p.licType === "corp"
        );
      }
      return [];
    },
    singleProduct() {
      return this.products.length === 1;
    },
    canSubmit() {
      return !!(this.email && this.gcid && this.prodid);
    }
  },
  watch: {
    products: {
      immediate: true,
      handler(prods) {
        if (prods.length === 1) {
          this.prodid = prods[0].id;
        } else if (!prods.some(p => p.id === this.prodid)) {
          this.prodid = 0;
        }
      }
    }
  },
  methods: {
    addLicense() {
      if (this.issuing || !this.canSubmit) {
        return;
      }
      this.issuing = true;
      this.$store
        .dispatch("geoContent/addLicense", {
          email: this.email,
          gcid: this.gcid,
          prodid: this.prodid,
          exp: this.exp,
          devnum: this.devnum
        })
        .then(() => {
          this.email = "";
          if (!this.singleProduct) {
            this.prodid = 0;
          }
        })
        .finally(() => {
          this.issuing = false;
        });
    }
  }
};
</script>

<style scoped>
#add_license {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 1.25rem;
}

.add-license-main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1.25rem;
}

.form-field {
  min-width: 0;
}

.form-field-email {
  flex: 1 1 16rem;
  max-width: 22rem;
}

.form-field-devnum {
  flex: 0 0 8.5rem;
}

.form-field-type {
  flex: 0 1 auto;
  min-width: 7rem;
}

.form-field-action {
  flex: 0 0 auto;
}

.form-label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #6c757d;
  white-space: nowrap;
}

.hint {
  font-weight: 400;
  color: #adb5bd;
}

.form-control {
  height: 2.25rem;
  border-color: #dee2e6;
  box-shadow: none;
}

.form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.15);
}

.type-static {
  margin: 0;
  height: 2.25rem;
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #212529;
}

@media (max-width: 575.98px) {
  .form-field-email,
  .form-field-devnum,
  .form-field-type,
  .form-field-action {
    flex: 1 1 100%;
    max-width: none;
  }

  .form-field-action .btn {
    width: 100%;
  }
}
</style>
